import { render, staticRenderFns } from "./CustomerTreatmentList.vue?vue&type=template&id=244ed644&scoped=true&"
import script from "./CustomerTreatmentList.vue?vue&type=script&lang=js&"
export * from "./CustomerTreatmentList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTreatmentList.vue?vue&type=style&index=0&id=244ed644&lang=scss&scoped=true&"
import style1 from "./CustomerTreatmentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ed644",
  null
  
)

export default component.exports